import {IFileSystemStrategy} from "./file-system.strategy.interface";
import {Directory, Filesystem} from "@capacitor/filesystem";

export class HybridFileSystemStrategy implements IFileSystemStrategy {
    async saveBlob(blob: Blob, fileName: string): Promise<void> {


        const reader = new FileReader();
        reader.onloadend = async () => {
            const base64Data = reader.result?.toString()?.split(",")[1]; // Convert blob în base64
            if (base64Data) {
                await Filesystem.writeFile({
                    path: fileName,
                    data: base64Data,
                    directory: Directory.Documents
                });
            } else {
                throw new Error("Conversion to base64 failed.");
            }
        };
        reader.readAsDataURL(blob);

    }

}